let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cGSfe"), load("8E4u5"), load("6wr18"), load("kjZZD"), load("ffEVr"), load("6KGrg"), load("4hZJd")]).then(() => parcelRequire('leLdu'));